export default "__VITE_ASSET__$GNhlnH___"